import { RhFormGroup, RhFormGroupItem } from "@rhythm-ui/react";
import { Field } from "formik";
import React from "react";

interface CheckBoxInputType {
  name: string;
  options: { value: string; label: string }[];
  alignment?: "Vertical" | "Horizontal";
  disabled?: boolean;
}

const CheckBoxInputFormik = ({
  name,
  options,
  alignment = "Vertical",
  disabled,
}: CheckBoxInputType) => {
  return (
    <div className={alignment === "Vertical" ? "[&>div]:flex-col" : " "}>
      <RhFormGroup className="flex-wrap">
        {/* <div className="flex flex-wrap justify-between"> */}
        {options.map((option: { value: string; label: string }) => (
          <RhFormGroupItem
            className=""
            key={option.value}
            control={
              <Field
                disabled={disabled}
                type="checkbox"
                className="m-tnano"
                name={name}
                data-testid={`RhFormGroupItem_${option.label}`}
                value={option.value}
              />
            }
            label={option.label}
          />
        ))}
        {/* </div> */}
      </RhFormGroup>
    </div>
  );
};

export default CheckBoxInputFormik;
